<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import PurchaseOrderForm from "./components/PurchaseOrderForm.vue"

defineProps<{
  purchase_order: {
    id?: number | null
    company_id: number | ""
    supplier_id: number | ""
    status: string
    expected_at: string
    notes: string
    items: Array<{
      id?: number | null
      product_id: number | ""
      quantity: string
      unit_price_cents: string
      ipi: string
      icms: string
    }>
  }
  suppliers: Array<{ label: string; value: number }>
  products: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <PurchaseOrderForm
      mode="create"
      title="PurchaseOrders/PurchaseOrdersNew"
      subtitle="Cadastre um pedido de compra em rascunho para envio ao fornecedor."
      :purchase-order="purchase_order"
      :suppliers="suppliers"
      :products="products"
      :errors="errors"
    />
  </AppShell>
</template>

